import { BaseClient } from '../client';
import { TAnuncioPagamento } from '../offer';
import { offerPaymentsMock } from './payment.mocks';

interface IGetPayment {
	dataCadastroInicial?: string;
	dataCadastroFinal?: string;
}

export const getAllPayment = async (params?: IGetPayment) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return offerPaymentsMock;
	// }

	try {
		const response = await BaseClient.post<TAnuncioPagamento[]>(`/Admin/GetAdminPagamento`, params).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
